import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const reputationBetContainer = style({
  display: 'flex',
  alignItems: 'center',
});

export const reputationBetProgressContainer = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
});

export const reputationBetProgress = style([
  responsiveStyle({
    mobile: {
      width: '47px',
      height: '28px',
    },
    laptop: {
      width: '66px',
      height: '36px',
    },
  }),
]);

export const semiCircleProgressBarValue = style({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  ...typography['bodySm'],
  lineHeight: 1,
});

export const reputationBetTextContainer = style({
  marginRight: space.s4,
  marginLeft: space.s12,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
});

export const reputationBetTitle = style([
  {
    color: themeVars.container.foreground.primary,
  },
  responsiveStyle({
    mobile: {
      ...typography['bodySm'],
      fontWeight: fontWeight.bold,
    },
    tablet: {
      ...typography['bodyMd'],
      fontWeight: fontWeight.bold,
    },
  }),
]);
export const reputationBetLabel = style([
  typography['bodySm'],
  {
    lineHeight: 1,
  },
]);

export const reputationBetHint = style({
  alignSelf: 'end',
  color: themeVars.container.foreground.primary,
});
